module.exports = __webpack_public_path__ + "static/mysa-mattress-2-031878d5be724a5cd54578f8682deadc.webp";